(() => {
  const looxReviews = document.querySelector('a[href="#looxReviews"]');
  const looxSection = looxReviews?.closest(".shopify-app-block");

  setTimeout(() => {
    if (looxSection && looxSection.offsetHeight > 0) {
      looxSection.style.maxWidth = "44rem";
      const negativeMargin = window.innerWidth >= 1024 ? "-40px" : "-25px";
      looxSection.style.marginTop = negativeMargin;
    }
  }, 128);
})();
